import { HttpParams } from '@angular/common/http';

import { supportedCarTrawlerCurrencies } from '@fcom/common/utils/thirdparty.utils';
import { allowedConfs } from '@fcom/core/reducers/langs';

import type { CarRentalSearchForm } from '../interfaces/car-rental.interface';

export interface CarRentalDeepLinkOptions {
  apiUrl: string;
  clientId: string;
  locale: string;
  currency: string;
}

const pad = (value: number): string => String(value).padStart(2, '0');

const toDateTime = (date: Date, time: string): string =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${time}`;

export const carRentalDeepLink = (form: CarRentalSearchForm, options: CarRentalDeepLinkOptions): string => {
  const { apiUrl, clientId, locale, currency } = options;
  const dropoffLocation = form.differentDropoff && form.dropoffLocation ? form.dropoffLocation : form.pickupLocation;

  const params: Record<string, string> = {
    clientId,
    currency,
    age: String(form.driverAge),
    ...(form.pickupLocation ? { pickupIATACode: form.pickupLocation.locationCode } : {}),
    ...(dropoffLocation ? { returnIATACode: dropoffLocation.locationCode } : {}),
    ...(form.pickupDate ? { pickupDateTime: toDateTime(form.pickupDate, form.pickupTime) } : {}),
    ...(form.dropoffDate ? { returnDateTime: toDateTime(form.dropoffDate, form.dropoffTime) } : {}),
  };

  const httpParams = Object.entries(params).reduce((acc, [key, value]) => acc.set(key, value), new HttpParams());

  return `${apiUrl}/${locale}/book?${httpParams.toString()}`;
};

export const DEFAULT_CURRENCY = 'EUR';

export const resolveCurrencyCode = (countryCode: string | null | undefined): string => {
  const normalizedCountryCode = (countryCode ?? '').trim().toUpperCase();
  const country = allowedConfs.find((conf) => conf.code === normalizedCountryCode);
  return supportedCarTrawlerCurrencies(country?.currencyCode ?? DEFAULT_CURRENCY);
};
